module.exports = __webpack_public_path__ + "sansg/img/ban.d8bd580d.png";